import { useEffect, useState } from "react";
import "./WazToolbar.css";
import { AppWindow, Bell, BookOpenCheck, Files, FileSearch, Home, MessageSquare, MessagesSquare, Plus, Ticket } from "lucide-react";
import { AppSidebar } from "../../app/sidebar/AppSidebar";
import { useNavigate } from "react-router-dom";
import { set } from "lodash";
import { useSelector } from "react-redux";
import { APP_MENUS, TOOLS, selectUIStates, setUIStates } from "../../../redux/features/appData";
import { useDispatch } from "react-redux";



type WazToolbarProps = {
    viewingApp?: boolean;
    viewingKB?: boolean;
}

export const WazToolbar = ({viewingApp = false, viewingKB = false }: WazToolbarProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const uiStates = useSelector(selectUIStates);
    const selectedTool = uiStates.selectedTool || TOOLS.HOME;

    const [isExpanded, setIsExpanded] = useState<boolean>(viewingApp);
    // const [isKBExpanded, setIsKBExpanded] = useState<boolean>(viewingKB);

    console.log("[WazToolbar] selectedTool: ", selectedTool);

    return (
        <>
           
            <div className="waz-toolbar">
                <div 
                    className={selectedTool === TOOLS.HOME ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        dispatch(setUIStates({...uiStates, selectedTool: TOOLS.HOME}));
                        navigate("/wazhome");
                    }}
                >
                    <Home size={16} />
                </div>

                <div 
                    className={selectedTool === TOOLS.CHAT ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        dispatch(setUIStates({...uiStates, selectedTool: TOOLS.CHAT}));
                        navigate("/chat");
                    }}
                >
                    <MessageSquare size={16} />
                </div>

                <div 
                    className={selectedTool === TOOLS.KB ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        if (selectedTool === TOOLS.KB) {
                            dispatch(setUIStates({...uiStates, selectedTool: TOOLS.HOME}));
                            navigate("/wazhome");
                        } else 
                        {
                            dispatch(setUIStates({...uiStates, selectedTool: TOOLS.KB}));
                            navigate("/kb");
                        }
                    }}
                >
                    <FileSearch size={16} />
                </div>
                
                
                {/* <div 
                    className={selectedTool === TOOLS.NEW ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => dispatch(setUIStates({...uiStates, selectedTool: TOOLS.NEW}))}
                >
                    <Plus size={16} />
                </div>

                <div 
                    className={selectedTool === TOOLS.CONVERSATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        dispatch(setUIStates({...uiStates, selectedTool: TOOLS.CONVERSATIONS}));
                        setIsExpanded(!isExpanded)
                    }}
                >
                    <MessagesSquare size={16} />
                </div> */}

                 <div 
                    className={selectedTool === TOOLS.DOCUMENTS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        dispatch(setUIStates({...uiStates, selectedTool: TOOLS.DOCUMENTS}));
                        setIsExpanded(!isExpanded)
                        navigate("/waz/documents");

                    }}
                >
                    <Files size={16} />
                </div>

                 <div 
                    className={selectedTool === TOOLS.POLICY_STUDIO ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        dispatch(setUIStates({...uiStates, selectedTool: TOOLS.POLICY_STUDIO}));
                        setIsExpanded(!isExpanded);
                        navigate("/wazps");

                    }}
                >
                    <BookOpenCheck size={16} />
                </div>



                {/* <div className="menu-icon">
                                  <img src={getNavIcon(MENUS.POLICY_STUDIO)} alt="" />
                                </div> */}

                {/* <div 
                    className={selectedTool === TOOLS.TICKET ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => dispatch(setUIStates({...uiStates, selectedTool: TOOLS.TICKET}))}
                >
                    <Ticket size={16} />
                </div>

                <div 
                    className={selectedTool === TOOLS.NOTIFICATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => dispatch(setUIStates({...uiStates, selectedTool: TOOLS.NOTIFICATIONS}))}
                >
                    <Bell size={16} />
                </div> */}

                <div 
                    className="waz-toolbar-login"
                    onClick={() => {
                        dispatch(setUIStates({...uiStates, selectedTool: TOOLS.APP}));
                        setIsExpanded(!isExpanded)

                        if (isExpanded) {      // go back to waz
                            navigate("/wazhome");
                        } else 
                        {
                            navigate("/app");
                        }
                        
                    }}
                >
                    <AppWindow size={16} color={isExpanded ? "red" : "black"} />
                </div>
                <div className="waz-toolbar-avatar">
                    <img src="https://s3.eu-central-1.amazonaws.com/xmp-hmn-objects/1bf1bebf80e8c0342c95edd1e6f878024430e22f22af17cd6f1a225761c027c9" />
                </div>
            </div>
            
            {/* {isExpanded &&
                <div className="waz-toolbar-expanded">
                    <div className="waz-toolbar-expanded-menu">
                        <div 
                            className={selectedTool === TOOLS.HOME ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => setSelectedTool(TOOLS.HOME)}
                        >
                            <Home size={16} />
                            
                        </div>
                        <span>Home</span>
                    </div>
                    
                    <div className="waz-toolbar-expanded-menu">
                        <div 
                            className={selectedTool === TOOLS.NEW ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => setSelectedTool(TOOLS.NEW)}
                        >
                            <Plus size={16} />
                        </div>
                        <span>New Conversation</span>
                    </div>

                    <div className="waz-toolbar-expanded-menu">

                        <div 
                            className={selectedTool === TOOLS.CONVERSATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => {
                                setSelectedTool(TOOLS.CONVERSATIONS)
                                setIsExpanded(!isExpanded)
                            }}
                        >
                            <MessagesSquare size={16} /> 
                        </div>
                        <span>Conversations</span>
                    </div>

                    <div className="waz-toolbar-expanded-menu">

                        <div 
                            className={selectedTool === TOOLS.TICKET ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => setSelectedTool(TOOLS.TICKET)}
                        >
                            <Ticket size={16} /> 
                            
                        </div>
                        <span>Tickets</span>
                    </div>

                    <div className="waz-toolbar-expanded-menu">
                        <div 
                            className={selectedTool === TOOLS.NOTIFICATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                            onClick={() => setSelectedTool(TOOLS.NOTIFICATIONS)}
                        >
                            <Bell size={16} />
                            
                        </div>
                        <span>Notifications</span>
                    </div>

                    <div className="waz-toolbar-login">
                        <div className="waz-toolbar-expanded-menu">
                            <AppWindow size={16} />
                            <span>Login</span>
                        </div>
                    </div>
                    <div className="waz-toolbar-avatar">
                        <div className="waz-toolbar-expanded-menu">
                            <img src="https://s3.eu-central-1.amazonaws.com/xmp-hmn-objects/1bf1bebf80e8c0342c95edd1e6f878024430e22f22af17cd6f1a225761c027c9" />
                            <span>Your Name</span>
                        </div>
                    </div>
                </div>
            } */}

            {/* {isExpanded && selectedTool === TOOLS.APP &&
                <AppSidebar />
            } */}
        </>
    )
}